import React from 'react';
import useDark from 'use-dark';

import imgSrc from '../assets/dark.jpg';

function DarkBase() {
  const ref = useDark(imgSrc);
  return (
    <header className="header">
      <canvas className="canvas" ref={ref} />
    </header>
  );
}

export default DarkBase;
